// extracted by mini-css-extract-plugin
export var lg = "_i-7";
export var md = "_i-6";
export var placeholderContainer = "_i-1";
export var placeholderIcon = "_i-2";
export var productImage = "_i-0";
export var sm = "_i-5";
export var xl = "_i-8";
export var xs = "_i-4";
export var xxs = "_i-3";